
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/child-safety-standards-policy",
      function () {
        return require("private-next-pages/[lang]/legal/child-safety-standards-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/child-safety-standards-policy"])
      });
    }
  